import { render, staticRenderFns } from "./Modelos.vue?vue&type=template&id=815b47c6"
import script from "./Modelos.vue?vue&type=script&lang=js"
export * from "./Modelos.vue?vue&type=script&lang=js"
import style0 from "./Modelos.vue?vue&type=style&index=0&id=815b47c6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QPage from 'quasar/src/components/page/QPage.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QForm from 'quasar/src/components/form/QForm.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QFile from 'quasar/src/components/file/QFile.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QCarousel from 'quasar/src/components/carousel/QCarousel.js';
import QCarouselSlide from 'quasar/src/components/carousel/QCarouselSlide.js';
import QCarouselControl from 'quasar/src/components/carousel/QCarouselControl.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QTr from 'quasar/src/components/table/QTr.js';
import QTd from 'quasar/src/components/table/QTd.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QPage,QCard,QForm,QInput,QSelect,QFile,QBtn,QCarousel,QCarouselSlide,QCarouselControl,QTable,QTr,QTd});
